import React, { Component } from 'react';
import { trim } from 'lodash';

class ReduxField extends Component {
  _dropDownChange = (event) => {
    const {
      input: { name },
      _dropDownChange,
    } = this.props;
    _dropDownChange({ name, value: event.target.value });
  };

  render() {
    const {
      input,
      type = 'text',
      meta,
      _dropDownChange = null,
      ...rest
    } = this.props;
    return (
      <>
        {type === 'dropdown' ? (
          <select
            className="form-control"
            {...rest}
            {...input}
            {...(_dropDownChange ? { onChange: this._dropDownChange } : {})}
          >
            {rest.placeholder && <option value="">{rest.placeholder}</option>}
            {rest.data.map((value, key) => (
              <option key={`reduxDropdown${key}`}>{value}</option>
            ))}
          </select>
        ) : null}

        {type === 'text' || type === 'number' || type === 'password' || type === 'checkbox' ? (
          <input {...rest} {...input} type={type} />
        ) : type === 'textarea' ? (
          <textarea {...rest} {...input} />
        ) : null}

        {meta.touched && meta.error && (
          <span className="pull-right text-danger">
            <i className="fa fa-exclamation-circle text-danger" />
            &nbsp;&nbsp;
            {meta.error}
          </span>
        )}
      </>
    );
  }
}

export const renderField = (props) => <ReduxField {...props} />;

export const required = (value) => (trim(value) ? undefined : 'Required');

export const requiredXray = (value) => (trim(value) ? undefined : 'You must enter X-ray name');

export const passwordsMustMatch = (value, allValues) => (value !== allValues.password ? 'Passwords do not match' : undefined);

export const passwordMaxLength = (value) => (value && !/^.{8,}$/i.test(value)
  ? 'Password must be at least 8 characters long.'
  : undefined);

export const passwordExtraMatches = (value) => (value && !/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/i.test(value)
  ? 'Password must be at least one uppercase letter, one lowercase letter, one number and one special character'
  : undefined);

export const maxLength = (max) => (value) => (value && value.length > max ? `Must be ${max} characters or less` : undefined);
export const maxLength25 = maxLength(25);
export const maxLength50 = maxLength(50);
export const maxLength3 = maxLength(3);

export const maxValue = (max) => (value) => (value && value > max ? `Age must be an integer between 1 and ${max}` : undefined);
export const maxValue120 = maxValue(120);

export const requiredAmount = (value) => (trim(value) ? undefined : 'You must input an amount.');

export const preferenceNameExtraMatches = (value) => (value && !/^[ _]*[A-Z0-9][A-Z0-9 _]*$/i.test(value)
  ? 'You can only use letters, numbers, spaces, and underscores in the preference name.'
  : undefined);

export const xRayName = (value) => (value && !/^[ _-]*[A-Z0-9][A-Z0-9 _-]*$/i.test(value)
  ? 'You can only use letters, numbers, spaces in the x-ray name.'
  : undefined);
